const languagesOrder = ['ENGLISH', 'RUSSIAN'];

export default languagesOrder;
